import type {
  ParametersAbstractParameter,
  ParametersPropertyKind,
  ParametersUnit,
} from "@/lib/api";

import type { TimeSeriesParameterOption } from "./time-series-parameter.types";

/** Property kind id → selectable display units. */
export type PropertyKindUnitsIndex = ReadonlyMap<string, ParametersUnit[]>;

export function indexPropertyKindUnits(
  propertyKinds: readonly ParametersPropertyKind[] | undefined,
): PropertyKindUnitsIndex {
  return new Map((propertyKinds ?? []).map((kind) => [kind.id, kind.units]));
}

/**
 * CMS passes the property-kind index to get selectable units. Dashboard callers
 * omit it: rendering uses the saved `config.unit`, never the option's units.
 */
export function toTimeSeriesParameterOption(
  parameter: Pick<ParametersAbstractParameter, "id" | "label" | "property_kind_id">,
  unitsByPropertyKind?: PropertyKindUnitsIndex,
): TimeSeriesParameterOption {
  return {
    id: parameter.id,
    label: parameter.label,
    propertyKindId: parameter.property_kind_id,
    units: unitsByPropertyKind?.get(parameter.property_kind_id) ?? [],
  };
}

export function unitDisplaySymbol(unit: ParametersUnit | undefined): string {
  if (!unit) return "";
  return unit.symbol ?? unit.name ?? unit.code;
}

export function resolveParameterUnit(
  parameter: TimeSeriesParameterOption,
  unitCode: string | undefined,
): ParametersUnit | undefined {
  if (unitCode) {
    const unit = parameter.units.find((candidate) => candidate.code === unitCode);
    if (unit) return unit;
  }
  return parameter.units[0];
}
